module.exports = __webpack_public_path__ + "img/COMBO RADIO 2 BW.6b5aaba.svg";